import { useEffect, useState } from "react";
import { toast } from "react-toastify";

// Custom hook for global offline detection
export default function useOfflineDetection() {
  const [hasShownOfflineToast, setHasShownOfflineToast] = useState(false);

  useEffect(() => {
    const handleOffline = () => {
      console.log('Browser went offline');

      if (!hasShownOfflineToast) {
        toast.info('You seem to be offline. Check your internet connection!”');
        setHasShownOfflineToast(true);
      }
    };

    const handleOnline = () => {
      console.log('Browser came back online');
      setHasShownOfflineToast(false); // Reset toast flag when back online
      toast.info('You’re back online!');
    };

    // Add event listeners
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    // Check initial state
    if (!navigator.onLine && !hasShownOfflineToast) {
      handleOffline();
    }

    // Cleanup
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, [hasShownOfflineToast]);
}